import { FJCommonAPIClass } from '@src/core/network/FJCommonAPI.ts';

class FJLinkedinAPIClass extends FJCommonAPIClass {
    // async fetchLinkedInUserProfile(accessToken: string) {
    //     const url = this._baseUrl + 'v1/third-party/linkedin-identity-me';
    //     const formData = new FormData();
    //     formData.append('access_token', accessToken);
    //     const res = await fetch(url, {
    //         method: 'POST',
    //         body: formData,
    //     });
    //     const response = await res.json();
    //     const { data, code } = response;
    //     if (code !== 200) {
    //         throw new Error(code.toString());
    //     }
    //     return data;
    // }

    async fetchLinkedInUserProfile(accessToken: string) {
        const url = this._baseUrl + 'v1/third-party/get-userinfo?access_token=' + accessToken;
        const res = await fetch(url, {
            method: 'GET',
        });
        const response = await res.json();
        const { data, code } = response;
        if (code !== 200) {
            throw new Error(code.toString());
        }
        return data;
    }
}

const _instance = new FJLinkedinAPIClass();
export default _instance;
